/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2021] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import Backbone from 'backbone';
import { Behavior } from 'backbone.marionette';

import Session from '../Session';
import makeFormReadOnly from '../util/makeFormReadOnly';
import { userHasRole } from '../util/RoleUtils';
import modelGet from '../util/modelGet';
import TaskStatusAlertView from '../views/TaskStatusAlertView';
import TaskActionsView from '../views/TaskActionsView';

const TaskBehavior = Behavior.extend({
  events: {
    'click .btn.release': 'onClickRelease',
    'click .btn.reassign': 'onClickReassign',
  },

  onBeforeRender() {
    this.model = new Backbone.Model(this.view.model.get('task'));
  },

  onRender() {
    const isTaskAssigned = this.model.get('isAssigned');
    const isTaskAssigneeCurrentUser = this.model.get('assignee') === Session.user.userName;
    const isTaskAssignedToCurrentUser = isTaskAssigned && isTaskAssigneeCurrentUser;
    const isTaskAdministrator = userHasRole('EMCEE - Task Admin');
    const departmentName = modelGet(this.model, 'taskData.departmentName');
    const isAssignedToUser = modelGet(this.model, 'targets.0.type') === 'user';

    // show the task status view
    const viewHasTaskStatusContainer = this.view.$('.task-status').length > 0;
    if (viewHasTaskStatusContainer) {
      this.view.addRegion('taskStatus', '.task-status');
      this.view.showChildView(
        'taskStatus',
        new TaskStatusAlertView({
          model: this.model,
          departmentName,
        })
      );
    }
    // Make the form read-only if the the person viewing the task is not
    // assigned, or is not the assigned user.
    if (!isTaskAssignedToCurrentUser) {
      makeFormReadOnly(this.view.$el);
    }

    // show the task actions view
    const viewHasTaskActionsContainer = this.view.$('.task-actions').length > 0;
    if (
      viewHasTaskActionsContainer &&
      ((isTaskAssigned && !isAssignedToUser && isTaskAssignedToCurrentUser) ||
        (isTaskAdministrator && !isAssignedToUser))
    ) {
      this.view.addRegion('taskActions', '.task-actions');
      this.view.showChildView(
        'taskActions',
        new TaskActionsView({
          model: this.model,
          departmentName,
        })
      );
    }
  },
});

export default TaskBehavior;
